/* NEXOWEAR · ficha del catálogo: cotizar por WhatsApp sin haber definido tallas.
   El botón principal «Solicitar cotización» exige al menos una unidad por talla; muchas empresas aún no tienen
   las tallas de su dotación. Este enlace manda lo que el cliente ya eligió (producto, REF, color, personalización)
   y deja la cantidad como aproximada. En celular agrega una barra inferior «Cotizar | WhatsApp».
   No toca nx-catalogo.js ni el carrito. */
(function () {
  'use strict';
  var me = document.currentScript;
  var WA = (me && me.getAttribute('data-nx-wa')) || '56988386146';

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function val(form, sel) { var el = form.querySelector(sel); return el ? (el.value || '').trim() : ''; }

  function message(form) {
    var title = txt(document.querySelector('.nx-info__title'));
    var ref = txt(document.querySelector('.nx-info .nx-ref')).replace(/^REF\s*/i, '');
    var color = val(form, 'input[name="nx-color"]:checked') || val(form, 'input[name="nx-color-txt"]');
    var perso = val(form, 'input[name="nx-perso"]:checked');
    var nota = val(form, '[data-nx-perso-nota]');
    var sizes = [];
    var total = 0;
    form.querySelectorAll('[data-nx-size]').forEach(function (i) {
      var q = parseInt(i.value, 10) || 0;
      if (q > 0) { sizes.push(i.getAttribute('data-nx-size') + ' × ' + q); total += q; }
    });
    var t = ['Hola NEXOWEAR, quiero cotizar:', '', '• Producto: ' + title + (ref ? ' (REF ' + ref + ')' : '')];
    if (color) t.push('• Color: ' + color);
    t.push(total ? '• Tallas: ' + sizes.join(', ') + ' (total ' + total + ')' : '• Cantidad aproximada: (por definir)');
    t.push('• Personalización: ' + (perso ? perso + (nota ? ' — ' + nota : '') : 'por definir'));
    t.push('', location.origin + location.pathname);
    return t.join('\n');
  }

  function init() {
    var form = document.querySelector('[data-nx-form]');
    if (!form || form.querySelector('[data-nx-quote-plus]')) return;
    var anchor = form.querySelector('.nx-alt') || form.querySelector('.nx-actions');
    if (!anchor) return;
    var p = document.createElement('p');
    p.className = 'nx-alt';
    p.innerHTML = '¿Aún no tienes las tallas de tu equipo? <a href="#" data-nx-quote-plus>Cotiza con una cantidad aproximada</a>';
    anchor.parentNode.insertBefore(p, anchor.nextSibling);
    p.querySelector('a').addEventListener('click', function (e) {
      e.preventDefault();
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(message(form)), '_blank', 'noopener');
    });
  }

  /* Barra inferior en celular: «Cotizar» (lleva al formulario) y «WhatsApp» (mensaje con lo elegido).
     Solo bajo 750 px; se esconde cuando los botones de la ficha están a la vista, para no duplicarlos. */
  function bar() {
    var form = document.querySelector('[data-nx-form]');
    var actions = document.querySelector('.nx-pdp .nx-actions');
    if (!form || !actions || document.querySelector('.nx-bar')) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var prices = Array.prototype.map.call(document.querySelectorAll('.nx-tiers [data-price]'), function (li) {
      return parseInt(li.getAttribute('data-price'), 10) || 0;
    }).filter(Boolean);
    var min = prices.length ? Math.min.apply(null, prices) : 0;
    var css = document.createElement('style');
    css.textContent =
      '.nx-bar{position:fixed;left:0;right:0;bottom:0;z-index:40;display:flex;align-items:center;gap:.8rem;padding:.8rem 1.2rem calc(.8rem + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #e1e6ec;box-shadow:0 -6px 18px rgba(0,25,49,.08);transform:translateY(110%);transition:transform .32s cubic-bezier(.2,.8,.2,1);font-family:inherit}' +
      '.nx-bar.is-on{transform:none}' +
      '.nx-bar__p{flex:1 1 auto;min-width:0;margin:0;font-size:1.15rem;line-height:1.25;color:#5f6b78}' +
      '.nx-bar__p strong{display:block;font-size:1.5rem;color:#001931}' +
      '.nx-bar__b{flex:none;display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 1.4rem;border-radius:8px;border:1px solid #001931;font:inherit;font-size:1.25rem;font-weight:600;text-decoration:none;cursor:pointer}' +
      '.nx-bar__b--dark{background:#001931;color:#fff}' +
      '.nx-bar__b--line{background:#fff;color:#001931}' +
      'body.nx-bar-on{padding-bottom:calc(68px + env(safe-area-inset-bottom))}' +
      'body.nx-bar-on gty-whatsapp-chat-button{display:none!important}' +
      '@media (min-width:750px){.nx-bar{display:none}}' +
      '@media (prefers-reduced-motion:reduce){.nx-bar{transition:none}}';
    document.head.appendChild(css);
    var el = document.createElement('div');
    el.className = 'nx-bar';
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'Cotizar este producto');
    el.innerHTML =
      '<p class="nx-bar__p">' + (min ? 'Desde <strong>$' + min.toLocaleString('es-CL') + ' neto</strong>' : '<strong>Cotiza con tu logo</strong>') + '</p>' +
      '<button type="button" class="nx-bar__b nx-bar__b--dark" data-nx-bar="form">Cotizar</button>' +
      '<button type="button" class="nx-bar__b nx-bar__b--line" data-nx-bar="wa">WhatsApp</button>';
    document.body.appendChild(el);
    el.querySelector('[data-nx-bar="form"]').addEventListener('click', function () {
      var target = form.querySelector('.nx-sizes') || form;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = form.querySelector('[data-nx-size]');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }, 500);
    });
    el.querySelector('[data-nx-bar="wa"]').addEventListener('click', function () {
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(message(form)), '_blank', 'noopener');
    });
    var gallery = document.querySelector('.nx-gallery') || document.querySelector('.nx-pdp');
    var ticking = false;
    function update() {
      ticking = false;
      var h = window.innerHeight || document.documentElement.clientHeight;
      var a = actions.getBoundingClientRect();
      var actionsVisible = a.bottom > 0 && a.top < h;
      var pastTop = gallery.getBoundingClientRect().bottom < 0;
      el.classList.toggle('is-on', mq.matches && pastTop && !actionsVisible);
      document.body.classList.toggle('nx-bar-on', mq.matches && pastTop);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function start() { init(); bar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
